import type { FunctionComponent } from 'preact';
import { TaskStatus } from './TaskStatus.js';
import { useTaskList } from '../CloudpackProvider/useTaskList.js';
import type { TaskDescription } from '@ms-cloudpack/api-server/browser';

export interface TaskListProps {
  searchFilter: string;
  issuesOnly: boolean;
}

/**
 * List of task results to be displayed inside the StatusDialog.
 */
export const TaskList: FunctionComponent<TaskListProps> = ({ searchFilter, issuesOnly }) => {
  const taskList = useTaskList();

  let filteredTasks = [...taskList.tasks].sort(sortTasks);
  if (searchFilter) {
    searchFilter = searchFilter.toLowerCase();
    filteredTasks = filteredTasks.filter(({ name }) => name?.toLowerCase().includes(searchFilter));
  }
  if (issuesOnly) {
    filteredTasks = filteredTasks.filter(({ errors, warnings }) => errors?.length || warnings?.length);
  }

  // These must be wrapped in a fragment for proper layout by the Dialog
  return (
    <>
      {filteredTasks.map((task, index) => (
        <TaskStatus key={task.name} index={index} task={task} />
      ))}
    </>
  );
};

/**
 * Really the server should be sorting. Get stuff out of the browser.
 */
function sortTasks(a: TaskDescription, b: TaskDescription): number {
  const aStatus = a.status === 'pending' ? 1 : 0;
  const bStatus = b.status === 'pending' ? 1 : 0;

  if (aStatus !== bStatus) {
    return aStatus > bStatus ? -1 : 1;
  }

  const aErrors = a.errors?.length || 0;
  const bErrors = b.errors?.length || 0;

  if (aErrors !== bErrors) {
    return aErrors > bErrors ? -1 : 1;
  }

  if (a.name === undefined && b.name === undefined) {
    return a.id < b.id ? -1 : 1;
  } else if (a.name === undefined) {
    return 1;
  } else if (b.name === undefined) {
    return -1;
  }

  return a.name < b.name ? -1 : 1;
}
